const DummyMargin = (props) => {
  return <div className={`mt-${props.size}`}>&nbsp;</div>;
};

export default DummyMargin;

DummyMargin.defaultProps = {
  size: 5,
};
